function canBeFlatten(value) {
    return value && typeof value === "object";
}
/**
 * Flatten the given object into one big fat object
 */
function flatten(object, separator, parent, root) {
    if (separator === void 0) { separator = "."; }
    if (parent === void 0) { parent = null; }
    if (root === void 0) { root = {}; }
    if (canBeFlatten(object) === false)
        return object;
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = object[key];
        var keyChain = parent ? parent + separator + key : key;
        if (Array.isArray(value) && value.length === 0) {
            root[keyChain] = value;
        }
        else if (canBeFlatten(value) === true) {
            flatten(value, separator, keyChain, root);
        }
        else {
            root[keyChain] = value;
        }
    }
    return root;
}

export { flatten as default };
